import React from 'react';

const HamIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12.92 7.92L5.29 15.55a3.35 3.35 0 0 0 4.74 4.74l7.63-7.63" />
    <path d="M19.8 3.5a6.1 6.1 0 0 0-8.13 1.07L4.74 11.5a6.1 6.1 0 0 0 8.63 8.63l6.93-6.93a6.1 6.1 0 0 0-1.07-8.13Z" />
    <path d="M15 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" />
    <path d="m13 10 3 3" />
  </svg>
);

export default HamIcon;